module.exports = __webpack_public_path__ + "static/media/illust04.3cea311e.png";